module.exports = __webpack_public_path__ + "static/media/red.ec85718b.png";